import { Module } from 'vuex';
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { ISearchState, IRootState } from '@/interfaces/store';

const namespaced: boolean = true;
const module: Module<ISearchState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};

export default module;
